import { render, staticRenderFns } from "./ProduzioneDistintaAvanzamento.vue?vue&type=template&id=5c542d8e&scoped=true&"
import script from "./ProduzioneDistintaAvanzamento.vue?vue&type=script&lang=js&"
export * from "./ProduzioneDistintaAvanzamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c542d8e",
  null
  
)

export default component.exports